import React from 'react';
export var CvvIconV2 = _ref => {
  var {
    ariaDescribedByContent,
    ariaDescribedById
  } = _ref;
  return React.createElement("svg", {
    fill: "none",
    role: "img",
    tabIndex: -1,
    viewBox: "0 0 56 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: ariaDescribedById
  }, ariaDescribedByContent), React.createElement("path", {
    d: "M0 2.894A2.887 2.887 0 0 1 2.88 0h50.24C54.71 0 56 1.296 56 2.894v28.212A2.887 2.887 0 0 1 53.12 34H2.88A2.887 2.887 0 0 1 0 31.106V2.894z",
    fill: "#003087"
  }), React.createElement("path", {
    d: "M0 7h56v7H0z",
    fill: "#56CCFE"
  }), React.createElement("path", {
    clipRule: "evenodd",
    d: "M50 20.96H40A1.04 1.04 0 0 0 38.96 22v6c0 .574.466 1.04 1.04 1.04h10A1.04 1.04 0 0 0 51.04 28v-6A1.04 1.04 0 0 0 50 20.96zM40 20a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H40z",
    fill: "#00CF92",
    fillRule: "evenodd"
  }), React.createElement("path", {
    d: "M41 24.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z",
    fill: "#EDEDED"
  }));
};